module.exports = __webpack_public_path__ + "img/控制台1.20c286d8.png";